import React from "react";
import MuiTable from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import { useTable, useSortBy } from "react-table";
import Typography from "@material-ui/core/Typography";
import { useTheme, Grid, IconButton, LinearProgress } from "@material-ui/core/";
import CallSplitIcon from "@material-ui/icons/CallSplit";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";

import { AddExpectedModal } from "./AddExpectedModal";
import { useExpectedUnitTypeList } from "../../../projectManagementQueries";
import { ExpectedUnitTypesTable } from "./ExpectedUnitTypesTable";

export const ExpectedUnitTypesPage = ({number, id }: any) => {
  const { data: unitTypesData = [], isLoading: isLoadingUnitTypes } = useExpectedUnitTypeList(id)

   if(isLoadingUnitTypes){
    return <LinearProgress />
  }
  



  return(
    <ExpectedUnitTypesTable data={unitTypesData} number={number} />
  )
};
